export const isValidCookingStep = (elem: TContent): boolean => !!elem.children.length;
